var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import {MuiThemeProvider } from '@material-ui/core/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import { makeStyles } from "@mui/styles";
import { Importer, ImporterField } from '../../csv_import/Importer';
//import { Importer, ImporterField } from "react-csv-importer";
import { useDrag } from '@use-gesture/react';
import {checkAuthentication} from '../../utils';



const pageStyles = makeStyles({

    root: {
        display: "flex",
 //       flexFlow: "column wrap",
        gap: "5px",
  //      height: "400px", 
        overflow: "auto",
        "& .MuiList-root": {      
            display: "block",
          //  flexFlow: "row",
            flexWrap: "nowrap",
            gap: "5px",
            height: "400px", // set the height limit to your liking
            overflow: "auto",
            width: "400px",
          
        },
        "& .MuiListItem-root": {
            width: 220,
            height: 12,
         //   color: "#772c97"
        },
        "& .MuiListItemText-root": {
        //    width: 180,
        //    height: 20,
            display: "flex",
            textAlign: "left",
            paddingLeft: "5px",
            alignItems: "center"
        },
        "& .MuiDialog-root": {           
            height: 500,
            fullwidth: true,
            maxWidth: 'lg'
        },
        "& .MuiDialogTitle - root": {
            textAlign: 'center',
            fontWeight: 500,
            fontSize: 'h4.fontSize',
            backgroundColor: "#1976d2",
            color: "#ffffff"
        },
        "& .MuiDialogContent-root": {
           height: 400
        },
        "& .MuiPaper-root": {
            height: 600
        }

    }

});

export default function Rates_Import() {
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [expand, setExpand] = React.useState(true);
    const [AllDoneAlert, setAllDoneAlert] = React.useState(false);
    const [successful, setSuccessful] = React.useState([])
    const [duplicates, setDuplicates] = React.useState([])
    const classes = pageStyles();

    var importRows = [];
    // var newRows = [];
    var rowCount;
    //var i;
    const processRows = (rows) => {
        console.log(`processRows`, rows)
        let processFields = Object.keys(rows[0]);
        console.log(`Fields`, processFields)
        for (var i = 0; i < rows.length; i++) {
            //      console.log(`loop`, rows[i])
            importRows.push(rows[i])
        }
        //newRows = [];
        pushRows(rows);
    };
    
     const pushRows = async (rows) => {
        await fetch("/api/importRates", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(rows)
        }).then(res => res.json())
            .then(json => {
                setSuccessful (json.successfulEntries)
                setDuplicates (json.duplicateEntries)
                setAllDoneAlert(true)
                console.log (AllDoneAlert)
        });
            
    };



    const onTrigger = React.useCallback((values) => {

      //  console.log("trigger")
      //  console.log('TriggerPropPick  ' + PropTypePick)
        const propString = PropTypePick.map((p) => { return `user_prop_type.ID=${p}` }).join(" OR ");
     //  console.log("ConfigString   " + propString)
      //  rosterData(propString)
      //      .then(setPropTypePick([]))
      //   console.log('config ProcessedData' , dataSet));
        setOpen(false);
        handleRosterCallback (propString)
        handleClose;
       
    });

    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setExpand(true);
    };
    
    const handleAlertClose = () => {
        setAllDoneAlert(false);
        handleClose()
    };

    React.useEffect(() => {
		checkAuthentication();
        if (refresh) {
            
            setRefresh(false);
        }
    });
    return (
        <Box sx={{
            width: 400,
            height: 600,
            boxSizing: 'border-box',
            lineHeight: 1.4
        }} >
            <MuiThemeProvider theme={muiThemeDesign}>
                <Button variant="contained" onClick={handleClickOpen}>
                    Import Rates
                </Button>
            <Dialog open={open}
                    onClose={handleClose}
                     maxWidth="lg"
          //      fullScreen
            >
                <DialogContent className={classes.overflow }>
                    <Box>
                        
                            <h1>Rates Import</h1>

                            <Importer
                                dataHandler={async (rows) => {
                                    // required, receives a list of parsed objects based on defined fields and user column mapping;
                                    // may be called several times if file is large
                                    // (if this callback returns a promise, the widget will wait for it before parsing more data)
                                    console.log("received batch of rows", rows);
                                    /*fetch("/api/importRates", {
                                        method: 'POST',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify(rows)
                                    }).then(res => res.json())
							            .then(json => {
							                setSuccessful (json.successfulEntries)
							                setDuplicates (json.duplicateEntries)
							                setAllDoneAlert(true)
							                console.log (AllDoneAlert)
						            });*/
                                    rowCount = rows.length;
                                    console.log(`rowCount`, rowCount)
                                    //   newRows.push(rows)
                                    processRows(rows)
                                    // mock timeout to simulate processing
                                 //   await new Promise((resolve) => setTimeout(resolve, 500));
                                }}
                                chunkSize={10000} // optional, internal parsing chunk size in bytes
                                defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
                                restartable={false} // optional, lets user choose to upload another file when import is complete
                                onStart={({ file, fields }) => {
                                    // optional, invoked when user has mapped columns and started import
                                    console.log("starting import of file", file, "with fields", fields);
                                }}
                                onComplete={({ file, fields }) => {
                                    // optional, invoked right after import is done (but user did not dismiss/reset the widget yet)
                                    //pushRows(importRows);
                                    console.log("finished import of file", file, "with fields", fields);
                                }}
                                onClose={() => {
                                    // optional, invoked when import is done and user clicked "Finish"
                                    // (if this is not specified, the widget lets the user upload another file)
                                    handleClose();
                                    console.log("importer dismissed");
                                }}
                            >
                                <ImporterField name="SOW" label="SOWName" />
                                <ImporterField name="Position" label="PositionName" />
                                <ImporterField name="Rate" label="Rate" />                       
                                
                          </Importer>
                        
                      </Box>
                </DialogContent>
            </Dialog> 
        </MuiThemeProvider>
        <Box
                className={classes.root }
                sx={{  
                    lineHeight: 1.1
                }}>
              <Dialog
                    open={AllDoneAlert}
                    onClose={handleAlertClose}
                    fullwidth="true"
                    maxWidth="lg"
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className={classes.root}
                >
                    <DialogTitle className={classes.root} id="alert-dialog-title" sx={{ textAlign: "center", color: "#ffffff", backgroundColor: "#1976d2" } }>
                        Your Import is Complete
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <Grid container>
                                <Grid item xs={6} sx={{ border: '1px solid gray' }}>
                                   
                                    <Typography textAlign="center" variant="h6" style={{ color: "black" }}>
                                        New Rates:
                                    </Typography>
                                
                                    <List>
                                        {successful.map(email => {
											 console.log("SOW Length:", email.SOW.length);
                                            return (
												<div key={email.SOW}>
													<div>
	                                                    <p>SOW: {email.SOW}</p>
	                                                </div>
	                                                <div>
	                                                    <p>Position:{email.Position}</p>
	                                                </div>
                                                </div>
                                            ) } )    
                                        }
                                    </List>
                                </Grid>
                            <Grid item xs={6} sx={{ border: '1px solid gray' }}>
                                <Typography textAlign="center" variant="h6" style={{ color: "black" }}>
                                    Already Existed Rates
                                </Typography>
                                    <List>
                                        {duplicates.map(email => {
                                            return (
                                                <div>
													<div>
	                                                    <p>SOW: {email.SOW}</p>
	                                                </div>
	                                                <div>
	                                                    <p>Position:{email.Position}</p>
	                                                </div>
                                                </div>
                                            ) })
                                        }
                                    </List>
                                </Grid>
                            </Grid>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        
                        <Button onClick={() => {
                            handleAlertClose()
                            
                        }} autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
                </Box >
            </Box>
   );
}
